import * as React from 'react';

import styled from '../../theme';
import { AboutRenderer, IRenderProps } from '../../models/About';

const Header = styled.div`
  text-align: center;
`;

const AwardsContainer = styled.div`
  margin-top: 30px;
`;

const AwardContainer = styled.div`
  display: flex;
  line-height: 1.5;

  > *:first-child {
    margin-right: 25px;
    width: 50px;
    text-align: right;
  }

  > *:nth-child(2) {
    width: 100%;
  }
`;

class Awards extends React.PureComponent<IRenderProps> {
  render() {
    return (
      <div>
        <Header>Awards</Header>
        <AwardsContainer>
          {this.props.data.fields.awards.map((award) => (
            <AwardContainer key={award.fields.title}>
              <div>{award.fields.year}</div>
              <div>{award.fields.title}</div>
            </AwardContainer>
          ))}
        </AwardsContainer>
      </div>
    );
  }
}

export default function Wrapper() {
  return <AboutRenderer render={Awards} />;
}



// WEBPACK FOOTER //
// ./src/scenes/About/Awards.tsx